import classNames from "classnames";

import {autoDuration} from "@/lib/format.tsx";
import {DataPoint, ServiceDefinition} from "@/lib/types/checks.ts";
import {rumLoadTimeCSSClass} from "@/pages/dashboard/display/dashboardUtils.ts";

import styles from "@/pages/dashboard/display/components/CheckCard.module.scss";

export const CheckResponseRumTime = ({
  responseTimeData,
  serviceDefinition,
}: {
  serviceDefinition: ServiceDefinition;
  responseTimeData: DataPoint[];
}) => (
  <>
    <div className={styles.checkCardStatName}>{serviceDefinition.performance_data_type_display} (1h)</div>
    <div className={classNames(styles.checkCardStatValue, rumLoadTimeCSSClass(responseTimeData[0].value))}>
      {autoDuration(responseTimeData[0].value)}
    </div>
  </>
);
